"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "interview",
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_441",
  "data-name": "Groupe 441",
  transform: "translate(0 12.157)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_440",
  "data-name": "Groupe 440"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2135",
  "data-name": "Trac\xE9 2135",
  d: "M75.206,98.35A10.089,10.089,0,0,0,79.4,90.223a10.593,10.593,0,0,0-21.172,0,10.048,10.048,0,0,0,3.607,7.668H54.8L45.926,89.32a1.355,1.355,0,0,0-1.871,0l-5.293,5.112a1.246,1.246,0,0,0,0,1.807l11.909,11.5a1.341,1.341,0,0,0,.936.374H62.193v8.945H39.523l6.569-9.514-2.2-1.417L36.343,117.06H33.081v-6.39a1.3,1.3,0,0,0-1.323-1.278H21.172v-5.112a6.4,6.4,0,0,0-4.189-5.931,10.089,10.089,0,0,0,4.189-8.126A10.422,10.422,0,0,0,10.586,80,10.422,10.422,0,0,0,0,90.223,10.089,10.089,0,0,0,4.189,98.35,6.4,6.4,0,0,0,0,104.281v17.891a6.513,6.513,0,0,0,6.616,6.39V143.9H9.263V128.561h9.263v14.057a1.3,1.3,0,0,0,1.323,1.278h9.263a1.3,1.3,0,0,0,1.323-1.278V123.449a6.214,6.214,0,0,0-1.326-3.834h9.265V141.34H33.081V143.9H46.314V141.34H41.021V119.616h9.3a6.186,6.186,0,0,0-1.358,3.834v19.169a1.3,1.3,0,0,0,1.323,1.278h9.263a1.3,1.3,0,0,0,1.323-1.278V128.561h9.263V143.9h2.647V128.561a6.513,6.513,0,0,0,6.616-6.39V104.281A6.4,6.4,0,0,0,75.206,98.35ZM2.647,90.223a7.815,7.815,0,0,1,7.94-7.668,7.672,7.672,0,1,1,0,15.335A7.815,7.815,0,0,1,2.647,90.223ZM30.435,117.06h-17.2V106.836H10.586v11.5a1.3,1.3,0,0,0,1.323,1.278H23.819a3.908,3.908,0,0,1,3.97,3.834V141.34H21.172V127.283a1.3,1.3,0,0,0-1.323-1.278H6.616a3.908,3.908,0,0,1-3.97-3.834V104.281a3.908,3.908,0,0,1,3.97-3.834h7.94a3.908,3.908,0,0,1,3.97,3.834v6.39a1.3,1.3,0,0,0,1.323,1.278H30.435ZM60.87,90.223a7.944,7.944,0,1,1,7.94,7.668A7.815,7.815,0,0,1,60.87,90.223Zm15.879,31.948a3.908,3.908,0,0,1-3.97,3.834H59.547a1.3,1.3,0,0,0-1.323,1.278V141.34H51.607V123.449a3.908,3.908,0,0,1,3.97-3.834h7.94a1.3,1.3,0,0,0,1.323-1.278v-11.5a1.3,1.3,0,0,0-1.323-1.278H52.155L41.569,95.335l3.422-3.3,8.327,8.042a1.342,1.342,0,0,0,.936.374H72.779a3.908,3.908,0,0,1,3.97,3.834Z",
  transform: "translate(0 -80)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: "0.5"
}))), /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_443",
  "data-name": "Groupe 443",
  transform: "translate(23.894)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_442",
  "data-name": "Groupe 442"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2136",
  "data-name": "Trac\xE9 2136",
  d: "M163.961,0H139.647A3.652,3.652,0,0,0,136,3.647v9.726a3.652,3.652,0,0,0,3.647,3.647h1.216v7.294a1.215,1.215,0,0,0,.75,1.123,1.2,1.2,0,0,0,.466.092,1.216,1.216,0,0,0,.859-.356l8.154-8.154h12.869a3.652,3.652,0,0,0,3.647-3.647V3.647A3.652,3.652,0,0,0,163.961,0Zm1.216,13.373a1.216,1.216,0,0,1-1.216,1.216H150.588a1.21,1.21,0,0,0-.86.356l-6.435,6.435V15.8a1.215,1.215,0,0,0-1.216-1.216h-2.431a1.216,1.216,0,0,1-1.216-1.216V3.647a1.216,1.216,0,0,1,1.216-1.216h24.314a1.216,1.216,0,0,1,1.216,1.216Z",
  transform: "translate(-136 0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: "0.5"
}))), /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_445",
  "data-name": "Groupe 445",
  transform: "translate(28.196 4.041)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_444",
  "data-name": "Groupe 444",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  id: "Rectangle_140",
  "data-name": "Rectangle 140",
  width: "6.412",
  height: "2.137",
  transform: "translate(0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: "0.5"
}))), /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_447",
  "data-name": "Groupe 447",
  transform: "translate(29.264 10.453)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_446",
  "data-name": "Groupe 446",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  id: "Rectangle_141",
  "data-name": "Rectangle 141",
  width: "21.374",
  height: "2.137",
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: "0.5"
}))), /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_449",
  "data-name": "Groupe 449",
  transform: "translate(37.814 4.041)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_448",
  "data-name": "Groupe 448",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  id: "Rectangle_142",
  "data-name": "Rectangle 142",
  width: "12.825",
  height: "2.137",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: "0.5"
}))));
let viewBox = '0 0 79.896 76.553';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'FormationIcon', viewBox);
